
const MUZIK_LISTEN = process.env.VUE_APP_MUZIK_LISTEN
const MUZIK_DOMAIN = process.env.VUE_APP_MUZIK_DOMAIN
// Lazy loading
const Layout = () => import(/* webpackChunkName: "Layout" */ '@/layouts/Layout')
// const Listen = () => import(/* webpackChunkName: "Listen" */ '@/pages/_locale/Listen')
const ScenarioById = () => import(/* webpackChunkName: "ScenarioById" */ '@/pages/_locale/scenario/_id')
const Composer = () => import(/* webpackChunkName: "Composer" */ '@/pages/_locale/composer')
const ComposerById = () => import(/* webpackChunkName: "ComposerById" */ '@/pages/_locale/composer/_id')
const WorkById = () => import(/* webpackChunkName: "WorkById" */ '@/pages/_locale/composer/_composer/_id')
const TrackById = () => import(/* webpackChunkName: "TrackById" */ '@/pages/_locale/track/_id')
const Performer = () => import(/* webpackChunkName: "Performer" */ '@/pages/_locale/performer')
const PerformerById = () => import(/* webpackChunkName: "PerformerById" */ '@/pages/_locale/performer/_id')
const PlaylistById = () => import(/* webpackChunkName: "PlaylistById" */ '@/pages/_locale/playlist/_id')

const Embed = () => import(/* webpackChunkName: "Embed" */ '@/layouts/Embed')
const EmbedPlaylistById = () => import(/* webpackChunkName: "EmbedPlaylistById" */ '@/pages/_locale/embed/playlists/_id')
const EmbedtrackById = () => import(/* webpackChunkName: "EmbedtrackById" */ '@/pages/_locale/embed/tracks/_id')

const listenMetaImage = `https://${MUZIK_LISTEN}.${MUZIK_DOMAIN}/img/cover-social/listen.png`

const listenRoutes = [
  // /////////////////////////
  // Migration from 聽古典
  // /////////////////////////
  {
    path: '/:locale/player/playlist/:playlistId/:startTrackId', // playlist 頁
    // redirect: '/:locale/playlists/:playlistId'
    redirect: to => {
      const { params } = to
      const formattedPath = `${params.locale}/playlists/${params.playlistId}`
      return { path: formattedPath, query: { start: params.startTrackId } }
    }
  },
  {
    path: '/:locale/scenario/:scenarioId', // scenario 頁
    redirect: '/:locale/scenarios/:scenarioId'
  },
  {
    path: '/:locale/track/:trackId', // track 頁
    redirect: '/:locale/tracks/:trackId'
  },
  {
    path: '/:locale/composer/:composerId/:workId', // work 頁
    redirect: '/:locale/composers/works/:workId'
  },
  {
    path: '/:locale/people/composer/:composerId', // composer 頁
    redirect: '/:locale/composers/:composerId'
  },
  {
    path: '/:locale/people/performer/:id', // performer 頁
    redirect: '/:locale/performers/:id'
  },
  {
    path: '/:locale/embed/track/:id', // embed track 頁
    redirect: '/:locale/embed/tracks/:id'
  },
  {
    path: '/:locale/embed/playlist/:id', // embed playlist 頁
    redirect: '/:locale/embed/playlists/:id'
  },
  // ////////////////////////
  {
    path: '/:locale/embed',
    component: Embed,
    children: [
      // {
      //   path: '',
      //   redirect: '/:locale/'
      // },
      // {
      //   path: '/playlists',
      //   redirect: '/:locale/'
      // },
      // {
      //   path: '/tracks',
      //   redirect: '/:locale/'
      // },
      // {
      //   path: '',
      //   redirect: '/:locale/'
      // },
      {
        path: 'playlists/:id',
        name: 'EmbedPlaylistById',
        component: EmbedPlaylistById,
        meta: {
          requiresAuth: false,
          breadcrumbs: [],
          metaInfo: {
            title: 'PLAYLIST.TITLE',
            meta: [
              // { vmid: 'image', name: 'image', content: listenMetaImage },
              // { vmid: 'og:image', name: 'og:image', content: listenMetaImage }
            ]
          }
        }
      },
      {
        path: 'tracks/:id',
        name: 'EmbedTrackById',
        component: EmbedtrackById,
        meta: {
          requiresAuth: false,
          breadcrumbs: [],
          metaInfo: {
            title: 'TRACK.TITLE',
            meta: [
              // { vmid: 'image', name: 'image', content: listenMetaImage },
              // { vmid: 'og:image', name: 'og:image', content: listenMetaImage }
            ]
          }
        }
      }
    ]
  },
  // {
  //   path: '/:locale/',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       name: 'listen',
  //       component: Listen,
  //       meta: {
  //         requiresAuth: false,
  //         breadcrumbs: [],
  //         metaInfo: {
  //           title: 'LISTEN.TITLE',
  //           meta: [
  //             { vmid: 'image', name: 'image', content: listenMetaImage },
  //             { vmid: 'og:image', name: 'og:image', content: listenMetaImage }
  //           ]
  //         }
  //       }
  //     }
  //   ]
  // },
  {
    path: '/:locale/scenarios',
    component: Layout,
    children: [
      {
        path: '',
        redirect: '/:locale/'
      },
      {
        path: ':id',
        name: 'scenarioById',
        props: true,
        component: ScenarioById,
        meta: {
          requiresAuth: false,
          breadcrumbs: [
            { routeName: 'index', localeLabel: 'LISTEN.TITLE', redirectPath: '' },
            { routeName: 'scenarioById', localeLabel: 'SCENARIO.TITLE', redirectPath: '' }
          ],
          metaInfo: {
            title: 'SCENARIO.TITLE',
            meta: [
              { vmid: 'image', name: 'image', content: listenMetaImage },
              { vmid: 'og:image', name: 'og:image', content: listenMetaImage }
            ]
          }
        }
      }
    ]
  },
  {
    path: '/:locale/playlists',
    component: Layout,
    children: [
      {
        path: '',
        redirect: '/:locale/'
      },
      {
        path: ':id',
        name: 'playlistById',
        props: true,
        component: PlaylistById,
        meta: {
          requiresAuth: false,
          breadcrumbs: [
            // update in page components mounted
            // { routeName: 'index', localeLabel: 'LISTEN.TITLE', redirectPath: '' }
            // { routeName: 'scenarioById', localeLabel: 'PLAYLIST.TITLE', redirectPath: '' }
          ],
          metaInfo: {
            title: 'PLAYLIST.TITLE',
            meta: [
              // { vmid: 'image', name: 'image', content: listenMetaImage },
              // { vmid: 'og:image', name: 'og:image', content: listenMetaImage }
            ]
          }
        }
      }
    ]
  },
  {
    path: '/:locale/composers',
    component: Layout,
    children: [
      {
        path: '',
        // redirect: '/:locale/'
        name: 'composer',
        props: true,
        component: Composer,
        meta: {
          requiresAuth: false,
          breadcrumbs: [
            { routeName: 'read', localeLabel: 'LISTEN.TITLE', redirectPath: '/' },
            { routeName: 'composer', localeLabel: 'COMPOSER.INDEX.TITLE', redirectPath: '' }
          ],
          metaInfo: {
            title: 'COMPOSER.INDEX.TITLE',
            meta: [
              { vmid: 'image', name: 'image', content: listenMetaImage },
              { vmid: 'og:image', name: 'og:image', content: listenMetaImage }
            ]
          }
        }
      },
      {
        path: ':id',
        name: 'composerById',
        props: true,
        component: ComposerById,
        meta: {
          requiresAuth: false,
          breadcrumbs: [
            // { routeName: 'listen', localeLabel: 'LISTEN.TITLE', redirectPath: '/' },
            // { routeName: '', localeLabel: 'COMPOSER.INDEX.TITLE', redirectPath: '' },
            // { routeName: 'composerById', localeLabel: 'COMMON.COMPOSER', redirectPath: '' }
          ],
          metaInfo: {
            title: 'COMPOSER.INDEX.TITLE',
            meta: [
              { vmid: 'image', name: 'image', content: listenMetaImage },
              { vmid: 'og:image', name: 'og:image', content: listenMetaImage }
            ]
          }
        }
      },
      {
        path: 'works/:workId',
        name: 'workById',
        props: true,
        component: WorkById,
        meta: {
          requiresAuth: false,
          breadcrumbs: [
            // { routeName: 'listen', localeLabel: 'LISTEN.TITLE', redirectPath: '' },
            // { routeName: '', localeLabel: 'COMPOSER.INDEX.TITLE', redirectPath: '' },
            // { routeName: 'composerById', localeLabel: 'COMMON.COMPOSER', redirectPath: '', routeParams: {id: ''} },
            // { routeName: 'workById', localeLabel: 'COMMON.WORK', redirectPath: '' }
          ],
          metaInfo: {
            title: 'COMPOSER.INDEX.TITLE',
            meta: [
              { vmid: 'image', name: 'image', content: listenMetaImage },
              { vmid: 'og:image', name: 'og:image', content: listenMetaImage }
            ]
          }
        }
      }
    ]
  },
  {
    path: '/:locale/tracks',
    component: Layout,
    children: [
      {
        path: '',
        redirect: '/:locale/'
      },
      {
        path: ':id',
        name: 'trackById',
        props: true,
        component: TrackById,
        meta: {
          requiresAuth: false,
          breadcrumbs: [
            // { routeName: 'index', localeLabel: 'LISTEN.TITLE', redirectPath: '' },
            // { routeName: 'composerById', localeLabel: 'COMMON.COMPOSER', redirectPath: '', routeParams: {id: ''} },
            // { routeName: 'workById', localeLabel: 'COMMON.WORK', redirectPath: '', routeParams: {workId: ''} },
            // { routeName: 'trackById', localeLabel: 'COMMON.TRACK', redirectPath: '' }
          ],
          metaInfo: {
            title: 'TRACK.TITLE',
            meta: [
              { vmid: 'image', name: 'image', content: listenMetaImage },
              { vmid: 'og:image', name: 'og:image', content: listenMetaImage }
            ]
          }
        }
      }
    ]
  },
  {
    path: '/:locale/performers',
    component: Layout,
    children: [
      {
        path: '',
        // redirect: '/:locale/'
        name: 'performer',
        props: true,
        component: Performer,
        meta: {
          requiresAuth: false,
          breadcrumbs: [
            { routeName: 'index', localeLabel: 'LISTEN.TITLE', redirectPath: '' },
            { routeName: 'performer', localeLabel: 'PERFORMER.INDEX.TITLE', redirectPath: '' }
          ],
          metaInfo: {
            title: 'PERFORMER.INDEX.TITLE',
            meta: [
              { vmid: 'image', name: 'image', content: listenMetaImage },
              { vmid: 'og:image', name: 'og:image', content: listenMetaImage }
            ]
          }
        }
      },
      {
        path: ':id',
        name: 'performerById',
        props: true,
        component: PerformerById,
        meta: {
          requiresAuth: false,
          breadcrumbs: [
            { routeName: 'index', localeLabel: 'LISTEN.TITLE', redirectPath: '' },
            { routeName: 'performer', localeLabel: 'PERFORMER.INDEX.TITLE', redirectPath: '' },
            { routeName: 'performerById', localeLabel: '-', redirectPath: '' }
          ],
          metaInfo: {
            title: 'PERFORMER.INDEX.TITLE',
            meta: [
              { vmid: 'image', name: 'image', content: listenMetaImage },
              { vmid: 'og:image', name: 'og:image', content: listenMetaImage }
            ]
          }
        }
      }
    ]
  }
]
export default listenRoutes
